import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('RadioUncheck', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M34 18H58",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M34 46H58",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("circle", {
    cx: "16",
    cy: "18",
    r: "10",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("circle", {
    cx: "16",
    cy: "46",
    r: "10",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});